import React from 'react'
import { Controller } from 'react-hook-form'
import { FormControlLabel, Switch } from '@material-ui/core'

const FormSwitch = ({ name, control, label }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error }, formState }) => (
        <FormControlLabel control={<Switch color={'primary'} onChange={onChange} checked={value} />} label={label} />
      )}
    />
  )
}

export default FormSwitch
